import React from 'react';

export const StepIconComponent = ({ active, completed }) =>
  active || completed ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <circle
        cx="6.5"
        cy="6.5"
        r="5.5"
        fill="#37BB7C"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
    >
      <circle cx="4.5" cy="4.5" r="4.5" fill="#D9D9D9" />
    </svg>
  );
